import { useState } from "react";

export function useToggleField(isSet?: boolean) {
  const [isOn, setIsOn] = useState(false);

  return {
    isOn: isOn || !!isSet,
    setOn: () => setIsOn(true),
    setOff: () => setIsOn(false),
  };
}
